const isNoCdlSelected = (mediaFullForm, mediaFormThis) => {
    const selectedLicenseType = mediaFormThis.formTypeInputFieldOptions.licenseTypes
        .find((ele,index) => ele.value === mediaFullForm.license_type)
    return selectedLicenseType && selectedLicenseType.slug === 'i-do-not-have-a-cdl'
}

export default {
    id: 2,
    mediaFormIsExperienceDisabled: (mediaFullForm, mediaFormThis) => isNoCdlSelected(mediaFullForm, mediaFormThis),
    mediaFormUpdated: (newValues, mediaFormThis) => {
        if (isNoCdlSelected(newValues, mediaFormThis)) mediaFormThis.mediaFullForm.experience = '0';
    },
    getFormTypeInputFields: () => [
        {
            name: 'license_type',
            options: (options) => options.licenseTypes,
            validation: {
                required: 'License Type field is required'
            },
        },
        'experienceFields',
        {
            name: 'valid_driver_license',
            options: 'yes-no',
            validation: {
                required: 'Valid driver license field is required',
            },
            show: (fields) => (fields.valid_driver_license || '').toLowerCase() === 'yes'
        },
        {
            name: 'owner_operator',
            options: 'yes-no',
            validation: {
                required: 'Owner operator field is required',
            },
            show: (fields) => (fields.owner_operator || '').toLowerCase() === 'yes'
        },
    ],
}
